
<template>
    <div class="floor">
        <div v-if="floors == '-1'" class="floorimg f-1">
            <ul>
                <li v-for="(item,key) in floorInfo.f_1.Info" :key="key">
                    <el-popover
                            placement="top-start"
                            :title="item"
                            trigger="hover"
                            style="display: block">
                        <div class="floor-info">
                            <p v-for="(items,index) in params_info">
                                <span class="key">{{items.name}}</span>
                                <span>{{params_info[index].value ? params_info[index].value : '?'}}</span>
                            </p>
                        </div>
                        <i slot="reference" @mouseover="get_temHum(item)"></i>
                    </el-popover>
                </li>
            </ul>
        </div>
        <div v-else-if="floors == '1'" class="floorimg f1">
            <ul>
                <li v-for="(item,key) in floorInfo.f1.Info" :key="key">
                    <el-popover
                            placement="top-start"
                            :title="item"
                            trigger="hover"
                            style="display: block">
                        <div class="floor-info">
                            <p v-for="(items,index) in params_info">
                                <span class="key">{{items.name}}</span>
                                <span>{{params_info[index].value ? params_info[index].value : '?'}}</span>
                            </p>
                        </div>
                        <i slot="reference" @mouseover="get_temHum(item)"></i>
                    </el-popover>
                </li>
            </ul>
        </div>
        <div v-else-if="floors == '2'" class="floorimg f2">
            <ul>
                <li v-for="(item,key) in floorInfo.f2.Info" :key="key">
                    <el-popover
                            placement="top-start"
                            :title="item"
                            trigger="hover"
                            style="display: block">
                        <div class="floor-info">
                            <p v-for="(items,index) in params_info">
                                <span class="key">{{items.name}}</span>
                                <span>{{params_info[index].value ? params_info[index].value : '?'}}</span>
                            </p>
                        </div>
                        <i slot="reference" @mouseover="get_temHum(item)"></i>
                    </el-popover>
                </li>
            </ul>
        </div>
        <div v-else-if="floors == '3'" class="floorimg f3">
            <ul>
                <li v-for="(item,key) in floorInfo.f3.Info" :key="key">
                    <el-popover
                            placement="top-start"
                            :title="item"
                            trigger="hover"
                            style="display: block">
                        <div class="floor-info">
                            <p v-for="(items,index) in params_info">
                                <span class="key">{{items.name}}</span>
                                <span>{{params_info[index].value ? params_info[index].value : '?'}}</span>
                            </p>
                        </div>
                        <i slot="reference" @mouseover="get_temHum(item)"></i>
                    </el-popover>
                </li>
            </ul>
        </div>
        <div v-else-if="floors == '4'" class="floorimg f4">
            <ul>
                <li v-for="(item,key) in floorInfo.f4.Info" :key="key">
                    <el-popover
                            placement="top-start"
                            :title="item"
                            trigger="hover"
                            style="display: block">
                        <div class="floor-info">
                            <p v-for="(items,index) in params_info">
                                <span class="key">{{items.name}}</span>
                                <span>{{params_info[index].value ? params_info[index].value : '?'}}</span>
                            </p>
                        </div>
                        <i slot="reference" @mouseover="get_temHum(item)"></i>
                    </el-popover>
                </li>
            </ul>
        </div>
        <div v-else-if="floors == '5'" class="floorimg f5">
            <ul>
                <li v-for="(item,key) in floorInfo.f5.Info" :key="key">
                    <el-popover
                            placement="top-start"
                            :title="item"
                            trigger="hover"
                            style="display: block">
                        <div class="floor-info">
                            <p v-for="(items,index) in params_info">
                                <span class="key">{{items.name}}</span>
                                <span>{{params_info[index].value ? params_info[index].value : '?'}}</span>
                            </p>
                        </div>
                        <i slot="reference" @mouseover="get_temHum(item)"></i>
                    </el-popover>
                </li>
            </ul>
        </div>
        <div v-else-if="floors == '7'" class="floorimg f7">
            <ul>
                <li v-for="(item,key) in floorInfo.f7.Info" :key="key">
                    <el-popover
                            placement="top-start"
                            :title="item"
                            trigger="hover"
                            style="display: block">
                        <div class="floor-info">
                            <p v-for="(items,index) in params_info">
                                <span class="key">{{items.name}}</span>
                                <span>{{params_info[index].value ? params_info[index].value : '?'}}</span>
                            </p>
                        </div>
                        <i slot="reference" @mouseover="get_temHum(item)"></i>
                    </el-popover>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { EncryptData } from '../assets/js/common/encrypt';
    export default {
        name: "Floors",
        props: {
            floors: Number,
        },
        data(){
          return {
              params_info: [
                { code: 'SA_T', name: '送风温度(℃)：',value: ''},
                { code: 'RA_T', name: '回风温度(℃)：',value: ''},
                { code: 'SA_H', name: '送风湿度(%)：',value: ''},
                { code: 'RA_H', name: '回风湿度(%)：',value: ''},
                { code: 'RA_T_SP', name: '回风温度设定(℃)：',value: ''},
              ],
              floorInfo:{
                  'f_1':{
                      Floor: '-1F',
                      Info:['KD01','XD05','KD08_1','KD02','KD04_2','KD08_4','KD05','KD08_2','KD08_3','KD07','KD08_5','XD06']
                  },
                  'f1':{
                      Floor: '1F',
                      Info:['K102','K103','K104','K105','X104','K101']
                  },
                  'f2':{
                      Floor: '2F',
                      Info:['K202','K205','K204','K206_2','K203','X201']
                  },
                  'f3':{
                      Floor: '3F',
                      Info:['K303_3','K303_5','X305','X307','X301','X306']
                  },
                  'f4':{
                      Floor: '4F',
                      Info:['K404','X406','X407_4','X401','X404','X407','X406_4','X405','X408']
                  },
                  'f5':{
                      Floor: '5F',
                      Info:['X502','X505','X506']
                  },
                  'f7':{
                      Floor: '7F',
                      Info:['X701','K701','X702']
                  },
              }
          }
        },
        methods: {
            //hover获取楼层单点温湿度信息
            get_temHum (location_code) {
                const _this = this;
                this.$api.systemInfo.floor_tem_hum(3, location_code, EncryptData({}))
                    .then( res => {
                      console.log(res);
                      if (res.data.flag === 0) {
                            _this.params_info = [
                          { code: 'SA_T', name: '送风温度(℃)：',value: ''},
                          { code: 'RA_T', name: '回风温度(℃)：',value: ''},
                          { code: 'SA_H', name: '送风湿度(%)：',value: ''},
                          { code: 'RA_H', name: '回风湿度(%)：',value: ''},
                          { code: 'RA_T_SP', name: '回风温度设定(℃)：',value: ''},
                        ];
                            this.$message.error({
                                message: res.data.code+'----'+res.data.msg.zh,
                                duration: 1200,
                            });
                        }
                        else {
                            if (res.data.code === 4018) {
                                _this.$message.error({
                                    message: res.data.code + "----无该设备信息",
                                    duration: 800,
                                });
                            }else{
                                for(let key in res.data.data.data){
                                  _this.params_info.forEach(item => {
                                    if(key == item.code)
                                      _this.$set(item,'value',res.data.data.data[key][0].toFixed(2));
                                  })
                                }
                            }
                        }
                    })
                    .catch( error => {
                        this.$message.error('E--获取楼层温湿度失败！！');
                    })
            }
        }
    }
</script>

<style lang="scss">
    .floor{
        .floorimg{
            position: relative;
            height:25rem;
            width: 90%;
            margin: auto;
            background:center no-repeat;
            background-size: 100% 100%!important;
            -webkit-background-size: 100% 100%!important;
            -moz-background-size: 100% 100%!important;
            ul {
                li {
                    .floor-info {
                        font-size: .6rem;
                    }
                    i {
                        position: absolute;
                        display:inline-block;
                        width: 16px;
                        height:16px;
                        background-color: rgba(255,0,0,.4);
                        border-radius: 50%;
                        animation: 1.2s point-flashing .1s linear infinite;
                        -wekit-animation: 1.2s point-flashing .1s linear infinite;
                        -o-animation: 1.2s point-flashing .1s linear infinite;
                        -moz-animation: 1.2s point-flashing .1s linear infinite;
                        cursor: pointer;
                    }
                    @keyframes point-flashing {
                        from { background-color: rgba(255,0,0,.4);}
                        to { background-color: red;}
                    }
                }
            }
        }
        /*'以下楼层点display: none的点均无法获取数据（后台无响应数据)'*/
        .f-1{
            background: url("../assets/img/index/-1F.jpg");
            li:nth-child(1) i{ display: none; top: 31%; left: 6%;}
            li:nth-child(2) i{ top: 61%; left: 13%;}
            li:nth-child(3) i{ top: 21%; left: 28%;}
            li:nth-child(4) i{ display: none; top: 31%; left: 31%;}
            li:nth-child(5) i{ top: 48%; left: 33%;}
            li:nth-child(6) i{ top: 54%; left: 38%;}
            li:nth-child(7) i{ display: none; top: 26%; left: 49%;}
            li:nth-child(8) i{ top: 20%; left: 68%;}
            li:nth-child(9) i{ top: 26%; left: 63%;}
            li:nth-child(10) i{ top: 47%; left: 58%;}
            li:nth-child(11) i{ top: 55%; left: 51%;}
            li:nth-child(12) i{ top: 60%; left: 45%;}
        }
        .f1 {
            background: url("../assets/img/index/1F.jpg");
            li:nth-child(1) i{ top: 2%; left: 24%;}
            li:nth-child(2) i{ top: 29%; left: 6%;}
            li:nth-child(3) i{ top: 59%; left: 7%;}
            li:nth-child(4) i{ top: 81%; left: 7%;}
            li:nth-child(5) i{ top: 80%; left: 28%;}
            li:nth-child(6) i{ top: 16%; left: 47%;}
        }
        .f2 {
            background: url("../assets/img/index/2F.jpg");
            li:nth-child(1) i{ top: 22%; left: 6%;}
            li:nth-child(2) i{ top: 51%; left: 6%;}
            li:nth-child(3) i{ top: 86%; left: 8%;}
            li:nth-child(4) i{ top: 20%; left: 29%;}
            li:nth-child(5) i{ top: 81%; left: 33%;}
            li:nth-child(6) i{ top: 12%; left: 46%;}
        }
        .f3 {
            background: url("../assets/img/index/3F.jpg");
            li:nth-child(1) i{ top: 2%; left: 23%;}
            li:nth-child(2) i{ top: 24%; left: 16%;}
            li:nth-child(3) i{ top: 62%; left: 4%;}
            li:nth-child(4) i{ top: 82%; left: 5%;}
            li:nth-child(5) i{ top: 2%; left: 51%;}
            li:nth-child(6) i{ top: 76%; left: 50%;}
            li:nth-child(7) i{ top: 29%; left: 40%;}
            li:nth-child(8) i{ top: 45%; left: 38%;}
            li:nth-child(9) i{ top: 56%; left: 38%;}
            li:nth-child(10) i{ top: 72%; left: 34%;}
            li:nth-child(11) i{ top: 56%; left: 38%;}
            li:nth-child(12) i{ top: 81%; left: 35%;}
            li:nth-child(13) i{ top: 93%; left: 32%;}
            li:nth-child(14) i{ top: 93%; left: 39%;}
            li:nth-child(15) i{ top: 87%; left: 48%;}
        }
        .f4 {
            background: url("../assets/img/index/4F.jpg");
            li:nth-child(1) i{ top: 8%; left: 14%;}
            li:nth-child(2) i{ top: 16%; left: 6%;}
            li:nth-child(3) i{ top: 35%; left: 18%;}
            li:nth-child(4) i{ top: 57%; left: 3%;}
            li:nth-child(5) i{ top: 80%; left: 3%;}
            li:nth-child(6) i{ top: 5%; left: 51%;}
            li:nth-child(7) i{ top: 29%; left: 42%;}
            li:nth-child(8) i{ top: 79%; left: 49%;}
            li:nth-child(9) i{ top: 3%; left: 95%;}
        }
        .f5 {
            background: url("../assets/img/index/5F.jpg");
            li:nth-child(1) i{ top: 5%; left: 14%;}
            li:nth-child(2) i{ top: 22%; left: 16%;}
            li:nth-child(3) i{ display: none; top: 4%; left: 91%;}
        }
        .f7 {
            background: url("../assets/img/index/7F.jpg");
            li:nth-child(1) i{ top: 30%; left: 28%;}
            li:nth-child(2) i{ top: 54%; left: 28%;}
            li:nth-child(3) i{ top: 95%; left: 50%;}
        }
    }

    .el-popover{
        width: 6.5rem!important;
        text-align: center!important;
        color: #eee!important;
        min-width: 5rem!important;
        line-height: 1rem!important;
        background-color: rgba(0,0,0,.6) !important;
        .el-popover__title {
            color: #eee!important;
            border-bottom: 1px solid #999;
        }
        p{
            margin-bottom: .2rem;
            .icon {
                font-size: .8rem;
                fill: orange!important;
                vertical-align: -.35rem
            }
        }
    }

</style>
